import DB from "@/common/utils/db";

/**
 * @description 获取年终数据
 */

export function retrieveYearReportData(query) {
    return DB({
        // v1/yearReport/retrieveYearReportDataH5?yearReportUUID=3ab3a4c8-2ee2-42ad-963c-fc769ad35510
        url: "v1/yearReport/retrieveYearReportData",
        method: "get",
        params: query
    });
}